import React from 'react';

import './HeaderLayout.scss';
interface HeaderLayoutProps {
	leading: JSX.Element,
	content: JSX.Element,
	trailing: JSX.Element,
}

function HeaderLayout(props: HeaderLayoutProps): JSX.Element {
	return (
		<nav className="header">
			<div className="header__leading">
				{props.leading}
			</div>
			<div className="header__main">
				{props.content}
			</div>
			<div className="header__trailing">
				{props.trailing}
			</div>
		</nav>
	);
}

export {HeaderLayout};